module.exports = __webpack_public_path__ + "static/media/OPDFacility.8d8303f9.png";